import gql from 'graphql-tag'

export default gql`
  query GetCartItem($cartId: UUID!, $itemId: UUID!) {
    cartItem(cartId: $cartId, itemId: $itemId) {
      ... on Error {
        message
      }
      ... on GenericCartItem {
        id
        sku
        name
        quantity
        options {
          id
          name
          value
        }
      }
      ... on GiftCardCartItem {
        id
        sku
        category
        name
        value
        recipientDetails {
          recipientName
          message
          ... on VirtualRecipientDetails {
            recipientEmail
            senderName
            deliveryDate
            deliveryMethod
          }
        }
      }
      ... on MarketplaceCartItem {
        id
        sku
        variantGroupCode
        shop {
          id
          name
        }
        name
        listPrice
        discountPrice
        quantity
        image {
          url
          description
        }
        optionValues {
          id
          optionId
          displayName
          value
        }
      }
    }
  }
`
